var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3795 10.7845L2.56924 20.5948M13.4312 3.07923C14.689 3.91384 15.898 4.89778 17.0277 6.02751C18.1672 7.16698 19.1584 8.38706 19.9976 9.65656M8.51218 7.57924L5.5434 6.58965C5.20151 6.47569 4.82492 6.54821 4.54981 6.781L1.59932 9.27756C0.995291 9.78867 1.1669 10.7613 1.90937 11.0349L4.70499 12.0648M11.0175 18.3772L12.0475 21.1728C12.321 21.9153 13.2937 22.0869 13.8048 21.4828L16.3013 18.5324C16.5341 18.2572 16.6067 17.8807 16.4927 17.5388L15.5031 14.57M18.9355 1.77008L13.8688 2.61454C13.3216 2.70572 12.8198 2.97464 12.4409 3.37968L5.61184 10.6797C3.84169 12.572 3.89093 15.527 5.72313 17.3592C7.55534 19.1914 10.5104 19.2406 12.4026 17.4705L19.7026 10.6414C20.1077 10.2625 20.3766 9.76069 20.4678 9.21358L21.3123 4.14685C21.5452 2.74899 20.3333 1.53711 18.9355 1.77008Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.812b3764ba45786affd2161d96fd362c.svg";
export { ForwardRef as ReactComponent };